import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsSsnField as SsnField } from './src/SsnField.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(SsnField);
export const FsSsnField = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-ssn-field.js.map